var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcGenericExpense = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 34,
  height: 34,
  viewBox: "0 0 34 34",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-Generic_expenses"
}, /*#__PURE__*/React.createElement("rect", {
  width: 34,
  height: 34
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Generic_expenses",
  clipPath: "url(#clip-Generic_expenses)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Union_24",
  "data-name": "Union 24",
  d: "M2506.828-5301.886c-5.143-9.38,1.128-21.178,11.77-21.922a17.166,17.166,0,0,1,2.6-.024,1.206,1.206,0,0,1-.008,2.385,11.765,11.765,0,0,1-1.606.068,11.268,11.268,0,0,0-1.981.115c-10.867,1.887-13.911,16.292-4.719,22.413,8.771,5.843,19.563-.931,19.126-11.3a10.616,10.616,0,0,1-.156-1.616,1.238,1.238,0,0,1,2.44-.055c.874,3.376-.243,7.917-2.1,10.8a14.628,14.628,0,0,1-12.417,6.756A14.617,14.617,0,0,1,2506.828-5301.886Zm12.827,1.417c-1.348-.1-1.093-1.607-1.151-2.552-1.738-.2-3.672-1.7-3.666-3.578a1.244,1.244,0,0,1,2.3-.683c.19.327.118.677.26.973.58,1.214,4.046,1.216,4.707.049.563-.989-1.2-1.544-1.917-1.611-1.813-.168-3.3-.068-4.576-1.66-1.991-2.479.143-5.354,2.918-5.592.008-.931-.239-2.457,1.05-2.612,1.569-.187,1.477,1.531,1.419,2.611a4.076,4.076,0,0,1,3.669,3.146c.15,1.123-.728,2.055-1.8,1.5-.822-.425-.454-1.253-.954-1.742-.824-.8-3.775-.831-4.428.174-.488.748.194,1.311.879,1.532a19.638,19.638,0,0,0,2.728.273c4.828.827,4.709,6.532-.061,7.222-.018,1.008.129,2.557-1.238,2.557C2519.751-5300.463,2519.7-5300.465,2519.656-5300.468Zm5.234-16.729,4.19-4.245h-2.193a1.587,1.587,0,0,1-.732-.5,1.238,1.238,0,0,1,.959-1.969,35.872,35.872,0,0,1,5.082,0,1.28,1.28,0,0,1,1.114,1.119,36.2,36.2,0,0,1,0,5.092,1.235,1.235,0,0,1-1.966.961,1.594,1.594,0,0,1-.5-.733v-2.2l-4.236,4.2a1.364,1.364,0,0,1-.7.2A1.244,1.244,0,0,1,2524.889-5317.2Z",
  transform: "translate(-2502.795 5325.779)",
  fill: "#fff"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcGenericExpense);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "matrices-static/media/ic_generic_expense.8429f285097eef8d1b8349a8e1af844d.svg";